import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import theme from './theme/theme';
import { AuthProvider } from './context/AuthContext';
import VpsNavbar from './components/vps/VpsNavbar';
import VpsFooter from './components/vps/VpsFooter';
import HomePage from './components/HomePage';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsAndConditions from './components/TermsAndConditions';
import RefundPolicy from './components/RefundPolicy';
import OrderDetail from './components/OrderDetail';
import LoginPage from './components/LoginPage';
import ProfilePage from './components/account/ProfilePage';
import ChangePasswordPage from './components/account/ChangePasswordPage';
import OrdersPage from './components/account/OrdersPage';
import PaymentsPage from './components/account/PaymentsPage';
import CheckoutDirect from './components/CheckoutDirect';

// Helper component to scroll window to top on route navigation
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <ScrollToTop />
          <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: '#FFFFFF' }}>
            <VpsNavbar />
            <Box sx={{ flex: 1 }}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/checkout" element={<OrderDetail />} />
                <Route path="/checkout-1" element={<CheckoutDirect />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                <Route path="/refund-policy" element={<RefundPolicy />} />

                {/* Account Pages */}
                <Route path="/account/profile" element={<ProfilePage />} />
                <Route path="/account/change-password" element={<ChangePasswordPage />} />
                <Route path="/account/orders" element={<OrdersPage />} />
                <Route path="/account/payments" element={<PaymentsPage />} />
              </Routes>
            </Box>
            <VpsFooter />
          </Box>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
